<div
  class="component-container"
  [style]="{
    backgroundColor: config().backgroundColor,
    borderRadius: config().borderRadius,
    border: config().border,
  }"
>
  @let bannerConfig = config().banner;
  @if (bannerConfig) {
    <p
      class="banner-text"
      [style]="{
        color: bannerConfig.textColor,
        fontFamily: bannerConfig.fontFamily,
        borderRadius: bannerConfig.borderRadius,
        backgroundColor: bannerConfig.backgroundColor,
        border: bannerConfig.border || bannerConfig.backgroundColor,
      }"
      [innerHTML]="displayText() | safe"
    ></p>
  }
  @let description = config().description;
  @if (description) {
    <p
      class="description"
      [style]="{
        color: description.textColor,
        fontFamily: description.fontFamily,
        fontSize: description.fontSize,
        backgroundColor: description.backgroundColor,
      }"
      [innerHTML]="description.text | safe"
    ></p>
  }
</div>
